<div>
  <i *ngIf="!hideIcon" class="icon-ico_eye_off automated-icon me-2 position"></i>
  {{ text }}
</div>
